import axiosInstance from '@/api/http';
import { IResponse } from '@/api/IResponse';
import CreateIMUserModel from '@/models/imusers/createIMUserModel';
import UpdateIMUserModel from '@/models/imusers/updateIMUserModel';
import UpdateStatusModel from '@/models/imusers/updateStatusModel';

export default class IMUserService {
  /**
   * @description: 查询IMUser信息
   * @page 页码
   * @size 每页大小
   * @return {Promise}
   */
  static getAll = (page: number, size: number, status: number, appId?: string, name?: string): Promise<IResponse> => {
    let url = `${appId}/imuser?page=${page}&size=${size}`;
    if (name) url += `&name=${name}`;
    if (status > -1) url += `&status=${status}`;
    return axiosInstance.get(url).then((res) => res.data);
  }

  /**
   * @description: 新增IMUser信息
   * @params {CreateCustomerModel} params
   * @return {Promise}
   */
  static create = (params: CreateIMUserModel, appId?: string): Promise<IResponse> => axiosInstance.post(`${appId}/imuser`, params).then((res) => res.data);

  /**
   * @description: 查询IMUser信息
   * @userId IMUserId
   * @return {Promise}
   */
  static get = (userId: string, appId?: string): Promise<IResponse> => axiosInstance.get(`${appId}/imuser/${userId}`).then((res) => res.data);

  /**
   * @description: 批量新增
   * @params {CreateCustomerModel} params
   * @return {Promise}
   */
  static batchCreate = (params: CreateIMUserModel[], appId?: string): Promise<IResponse> => axiosInstance.put(`${appId}/imuser/batch`, params).then((res) => res.data);

  /**
   * @description: 删除指定IMUser
   * @customerId 客户Id
   * @return {Promise}
   */
  static delete = (userId: string, appId?: string): Promise<IResponse> => axiosInstance.delete(`${appId}/imuser/${userId}`).then((res) => res.data);

  /**
   * 修改用户信息
   * @param userId
   * @param params
   * @returns
   */
  static update = (userId: string, params: UpdateIMUserModel, appId?: string): Promise<IResponse> => axiosInstance.put(`${appId}/imuser/${userId}`, params).then((res) => res.data);

  /**
   * 重置密码
   * @param userId
   * @returns
   */
  static reSetPassword = (userId: string, appId?: string): Promise<IResponse> => axiosInstance.post(`${appId}/imuser/resetPass/${userId}`).then((res) => res.data);

  /**
   * 修改用户状态
   * @param UpdateStatusModel
   * @returns
   */
  static updateStatus=(params:UpdateStatusModel, appId?: string): Promise<IResponse> => axiosInstance.post(`${appId}/imuser/updateimuserstatus`, params).then((res) => res.data);
}
